"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/app/_components/ui/select";
import { SchoolWorkerTypeEnumToStr } from "@/lib/enumMappings";
import { SchoolWorkerType } from "@prisma/client";

const ROLE_OPTIONS = Object.entries(SchoolWorkerTypeEnumToStr) as [
  SchoolWorkerType,
  string,
][];

export function RoleDropdown({
  value,
  onValueChange,
  placeholder = "Select role or title",
}: {
  value?: SchoolWorkerType;
  onValueChange?: (value: SchoolWorkerType) => void;
  placeholder?: string;
}) {
  return (
    <Select
      value={value}
      onValueChange={(next) => {
        if (!next) {
          return;
        }
        onValueChange?.(next as SchoolWorkerType);
      }}
    >
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent data-theme="lavender">
        {ROLE_OPTIONS.map(([role, label]) => (
          <SelectItem key={role} value={role}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
